import React, { useState } from 'react'
import { Avatar, Button, ButtonGroup, Card, CardActions, CardHeader, Input } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { AccountBalanceWalletOutlined, AddCircleOutline, RemoveCircleOutline, ShoppingBasketOutlined } from '@mui/icons-material';

// function NftMinCard({ image, title, content, handleClick }) {
function NftMinCard(props) {

    const [quantity, setQuantity] = useState(1);

    const updateQuantity = (qty) => {
        if (quantity + qty < 1 || quantity + qty > 10) return;

        setQuantity((prevQty) => prevQty + parseInt(qty));
    }

    // const mainColor = "#1976de";
    const mainColor = "#ccc";

    return (
        <Card className='nft-card' sx={{ backgroundColor: "black", borderRadius: "20px" }}>
            <CardHeader
                title={
                    <Typography variant="title1" sx={{ color: mainColor, fontSize: "20px", fontWeight: "bold" }}>
                        {props.title}
                    </Typography>
                }
                subheader={
                    <Typography variant="subtitle1" sx={{ color: mainColor }}>
                        {"Remaining " + (props.supply - props.minted) + " / " + props.supply}
                    </Typography>
                }
                avatar={
                    <Avatar sx={{ bgcolor: "#1976de" }} aria-label="recipe">
                        {props.tier}
                    </Avatar>
                }
                sx={{ color: "white", flexDirection: "row-reverse" }}
            />
            <CardMedia
                component="img"
                alt="nft image"
                image={props.image}
                sx={{ borderRadius: "20px", width: "90%", margin: "auto" }}
            />
            <CardContent>
                <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="Disabled elevation buttons"
                    sx={{ height: "45px" }}
                >
                    <Button variant="outlined" sx={{ fontSize: "24px", width: "45px" }} onClick={() => updateQuantity(-1)}><RemoveCircleOutline /></Button>
                    <Input value={quantity} sx={{ border: "0.5px #1976de solid", borderRadius: "0px" }} inputProps={{ style: { color: mainColor, textAlign: "center" } }} />
                    <Button variant="outlined" sx={{ fontSize: "24px", width: "45px" }} onClick={() => updateQuantity(1)}><AddCircleOutline /></Button>
                </ButtonGroup>
                <Typography sx={{ color: mainColor, fontSize: "16px", fontWeight: "bold", paddingTop: "20px", display: "flex", justifyContent: "center" }}>
                    <ShoppingBasketOutlined sx={{ marginRight: "8px" }} /> {"Total: " + (quantity * props.prices[props.tier - 1]).toFixed(3) + " ETH + Gas"}
                </Typography>
            </CardContent>
            <CardActions>
                <Button variant={props.isWalletConnected ? "contained" : "outlined"} startIcon={<AccountBalanceWalletOutlined />} onClick={() => props.handleClick({quantity: quantity, tier: props.tier})} sx={{ width: "100%", margin: "0px 20px 20px 20px" }}>MINT</Button>
            </CardActions>
        </Card>
    );
}
export default NftMinCard;